import { Url } from '../components/UrlServer'
import http from '../services/http-request'
import { OrderPrepare } from './types'

// PRODUCTS API
export const fetchProducts = () => http.get(`${Url}/products`)
export const getProductDetails = (id: string) =>
  http.get(`${Url}/products/details/${id}`)
export const deleteProduct = (id: string) =>
  http.delete(`${Url}/products/delete-product/${id}`)
export const updateProduct = (form: unknown) =>
  http.post(`${Url}/products/update-product`, form)
// CATEGORIES API
export const fetchCategories = () => http.get(`${Url}/cate`)
export const deleteCategory = (id: string) => http.delete(`${Url}/cate/${id}`)
export const addCategory = (form: unknown) => http.post(`${Url}/cate`, form)
// USER API
export const userLogin = (payload: unknown) =>
  http.post(`${Url}/ath/login`, payload)
export const userInfor = () => http.get(`${Url}/ath/infor`)
export const userRegister = (payload: unknown) =>
  http.post(`${Url}/ath/register`, payload)
export const userLogout = () => http.delete(`${Url}/ath/logout`)
export const userRemoveFromCart = (payload: string) =>
  http.get(`${Url}/ath/cart-delete?id=${payload}`)
export const userUpdateToCart = (id: string, type: string) =>
  http.get(`${Url}/ath/update?id=${id}&type=${type}`)

// CHECK OUT
export const checkout = (data: OrderPrepare) =>
  http.post(`${Url}/order/checkout`, data)
// ORDER API
export const getOrders = () => http.get(`${Url}/order/orders`)
export const adminOrders = () => http.get(`${Url}/order/get-all-orders`)
export const adminDeleteOrders = (id: string) =>
  http.delete(`${Url}/order/delete-order/${id}`)
export const adminUpdateOrders = (status: unknown) =>
  http.post(`${Url}/order/update-status`, status)

// CART API
export const addToCart = (data: { product_id: string }) =>
  http.post(`${Url}/cart/add-to-cart`, data)
export const getCart = () => http.get(`${Url}/cart`)

export const deleteItemInCart = (id: string) =>
  http.delete(`${Url}/cart/delete/${id}`)

export const modifyItemInCart = (id: string, type: 'add' | 'sub') =>
  http.post(`${Url}/cart/mod?itemID=${id}&type=${type}`)
